import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useStudentMetrics } from '../hooks/useStudentMetrics';
import { formatNumber } from '../utils/formatters';

interface StudentMetricsCardsProps {
  onFilterChange: (filter: string) => void;
  activeFilter: string;
}

export function StudentMetricsCards({ onFilterChange, activeFilter }: StudentMetricsCardsProps) {
  const { metrics, loading } = useStudentMetrics();

  const cards = [
    {
      id: 'total',
      title: 'Total de Alunos',
      value: metrics.total_alunos,
      description: 'Alunos cadastrados',
      filterValue: 'all'
    },
    {
      id: 'active',
      title: 'Alunos Ativos',
      value: metrics.alunos_ativos,
      description: 'Acessaram a plataforma',
      filterValue: 'active'
    },
    {
      id: 'loyal',
      title: 'Alunos Fiéis',
      value: metrics.alunos_fieis,
      description: 'Mais de um curso',
      filterValue: 'loyal'
    },
    {
      id: 'new',
      title: 'Novos Alunos',
      value: metrics.novos_alunos,
      description: 'Cadastrados este mês',
      filterValue: 'new'
    }
  ];

  return (
    <div className="grid grid-cols-4 gap-4">
      {cards.map((card) => (
        <Card 
          key={card.id}
          className={`cursor-pointer transition-all duration-200 ${
            activeFilter === card.filterValue 
              ? 'ring-2 ring-primary bg-primary/5' 
              : 'hover:bg-background-hover'
          }`}
          onClick={() => onFilterChange(card.filterValue)}
        >
          <CardHeader>
            <CardTitle className="text-base">{card.title}</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-2xl font-bold">
              {loading ? "..." : formatNumber(card.value)}
            </p>
            <p className="text-sm text-emerald-400 mt-1">
              {card.description}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}